<template>
  <div class="ReviewPreview">
    <ReviewExternal
      v-if="hasReview"
      :reviewExternal="reviewExternal" />
    <DiffLaptops
      :incoming="reviewExternal.laptop"
      :original="laptop" />
  </div>
</template>

<script>
import DiffLaptops from '@components/DiffLaptops'
import ReviewExternal from '@components/ReviewExternal'

export default {
  components: {
    DiffLaptops,
    ReviewExternal,
  },
  props: {
    laptop: { type: Object, required: true },
    reviewExternal: { type: Object, required: true },
  },
  computed: {
    hasReview() {
      return this.reviewExternal.url
    },
  },
}
</script>

<style lang="scss">
.ReviewPreview {
}
</style>
